import {
  ContextMenuItem,
  ContextMenuSub,
  ContextMenuSubContent,
  ContextMenuSubTrigger,
} from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import {
  ACTION_PERMISSION_KEYS,
  ACTION_PERMISSION_VALUES,
  PAGE_PERMISSION_KEYS,
} from "@/lib/data/static/permissionOptions";
import { History, List, Plus } from "lucide-react";

export function MatterExpenseUpdatesContextMenu({
  onOpenUpdates,
  onCreateUpdate,
}: {
  onOpenUpdates: () => void;
  onCreateUpdate: () => void;
}) {
  const { hasPagePermission, hasActionPermission } = useUser();
  if (
    !hasPagePermission(PAGE_PERMISSION_KEYS.mattersDetailUpdates) ||
    !hasPagePermission(PAGE_PERMISSION_KEYS.mattersDetailCosts)
  )
    return null;
  const canCreate = hasActionPermission(
    ACTION_PERMISSION_KEYS.objectUpdate,
    ACTION_PERMISSION_VALUES.create,
  );

  return (
    <ContextMenuSub>
      <ContextMenuSubTrigger>
        <History />
        Updates
      </ContextMenuSubTrigger>
      <ContextMenuSubContent>
        <ContextMenuItem onSelect={onOpenUpdates}>
          <List />
          Open updates
        </ContextMenuItem>
        {canCreate ? (
          <ContextMenuItem onSelect={onCreateUpdate}>
            <Plus />
            Create update
          </ContextMenuItem>
        ) : null}
      </ContextMenuSubContent>
    </ContextMenuSub>
  );
}
